import { useIsActivateEnabled } from '@modules/activate/hooks';
import { CircularLoader } from '@modules/common/components/CircularLoader';
import { useIsSearchToFeedEnabled } from '@modules/common/hooks';
import { useInitSearchStore } from '@modules/feed/hooks';
import { useSearchStore } from '@modules/feed/store/searchStore';
import { Box } from '@mui/material';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';
import { BasicSearch } from '../BasicSearch';
import { SearchAnalyses } from '../SearchAnalyses';

export function FeedContainer() {
  const isSearchToFeedEnabled = useIsSearchToFeedEnabled();
  const isActivateEnabled = useIsActivateEnabled();

  const { isLoading, hasWhereClause, error } = useInitSearchStore();
  const isDataPresent = useSearchStore(({ data }) => Boolean(data?.id));

  const { savedSlug } = useParseSavedSlugInfo();
  const isSavedSearchView = Boolean(savedSlug);

  const isDataBeingPopulated = isSavedSearchView && !isDataPresent && !error;

  if (isLoading || isDataBeingPopulated) {
    return (
      <Box height="calc(100vh - 72px)">
        <CircularLoader />
      </Box>
    );
  }

  if (hasWhereClause || isSearchToFeedEnabled || isActivateEnabled) {
    return <SearchAnalyses />;
  }

  return <BasicSearch />;
}
